module.exports = "<router-outlet></router-outlet>\n<!-- /.o-collapsible-container -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/performance/performance-reports/performance-reports.component.html
// module id = ./src/app/routes/performance/performance-reports/performance-reports.component.html
// module chunks = 9